import classNames from "classnames";
import { deltaTone, formatDeltaPct, type DeltaTone } from "../_helpers/delta";

interface KpiTileProps {
    label: string;
    count: number;
    // null = no honest prior window (zero prior, or a point-in-time metric)
    // — the delta line is omitted entirely.
    deltaPct: number | null;
    // Direction that renders green. ordersPlaced: increase = good (true).
    // The story flips ordersShipped / itemsLowStock / issuesFound (false).
    // Kept as a per-tile flag so reversing a tile is a one-line change —
    // the ordersShipped flip is flagged to the Lead as a suspected
    // story-text error (more shipped orders should read as good).
    positiveIsGood: boolean;
}

const TONE_CLASS: Record<DeltaTone, string> = {
    good: "text-success",
    bad: "text-error",
    neutral: "text-neutral",
};

export const KpiTile = ({
    label,
    count,
    deltaPct,
    positiveIsGood,
}: KpiTileProps) => {
    return (
        <div className="flex aspect-square w-full flex-col items-center justify-center gap-1 rounded-full border border-base-300 shadow-sm">
            <span className="text-5xl font-bold text-primary">{count}</span>
            <span className="text-lg text-neutral">{label}</span>
            {deltaPct !== null && (
                <span
                    className={classNames(
                        "text-sm font-semibold",
                        TONE_CLASS[deltaTone(deltaPct, positiveIsGood)],
                    )}
                >
                    {formatDeltaPct(deltaPct)}
                </span>
            )}
        </div>
    );
};
